/**
 * @generated SignedSource<<5f819ef7a7ceea81093f38306bcd467a>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Query } from 'relay-runtime';
type RegistriesChooser_team$fragmentType = any;
export type RegistriesChooserQuery$variables = {|
  registryAddSearch?: ?string,
  team: string,
  teamSelector?: ?any,
|};
export type RegistriesChooserQuery$data = {|
  +team: ?{|
    +$fragmentSpreads: RegistriesChooser_team$fragmentType,
  |},
|};
export type RegistriesChooserQuery = {|
  response: RegistriesChooserQuery$data,
  variables: RegistriesChooserQuery$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "registryAddSearch"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "team"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamSelector"
},
v3 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "team"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RegistriesChooserQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "registryAddSearch",
                "variableName": "registryAddSearch"
              },
              {
                "kind": "Variable",
                "name": "teamSelector",
                "variableName": "teamSelector"
              }
            ],
            "kind": "FragmentSpread",
            "name": "RegistriesChooser_team"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "RegistriesChooserQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Team",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "order",
                    "value": "NAME"
                  },
                  {
                    "kind": "Variable",
                    "name": "search",
                    "variableName": "registryAddSearch"
                  },
                  {
                    "kind": "Variable",
                    "name": "team",
                    "variableName": "teamSelector"
                  }
                ],
                "concreteType": "RegistryConnection",
                "kind": "LinkedField",
                "name": "registries",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RegistryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Registry",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TeamPermissions",
            "kind": "LinkedField",
            "name": "permissions",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Permission",
                "kind": "LinkedField",
                "name": "teamRegistryCreate",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "allowed",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5f8b3729581c5179a710fd81b421648e",
    "id": null,
    "metadata": {},
    "name": "RegistriesChooserQuery",
    "operationKind": "query",
    "text": "query RegistriesChooserQuery(\n  $team: ID!\n  $registryAddSearch: String\n  $teamSelector: TeamSelector\n) {\n  team(slug: $team) {\n    ...RegistriesChooser_team_vfPVS\n    id\n  }\n}\n\nfragment RegistriesChooser_team_vfPVS on Team {\n  id\n  slug\n  organization {\n    registries(search: $registryAddSearch, first: 10, order: NAME, team: $teamSelector) {\n      edges {\n        node {\n          id\n          name\n          slug\n        }\n      }\n    }\n    id\n  }\n  permissions {\n    teamRegistryCreate {\n      allowed\n    }\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "251c66f4de2b47ee2b6925acd27ac9fb";

module.exports = ((node/*: any*/)/*: Query<
  RegistriesChooserQuery$variables,
  RegistriesChooserQuery$data,
>*/);
